// extracted by mini-css-extract-plugin
export default {"wrapper":"SubscriptionsAndAddons_wrapper__0JfJI","border":"SubscriptionsAndAddons_border__d+U13"};